import { cva } from 'class-variance-authority';

export const iconVariants = cva([
  '[&>svg]:fill-current',
  '[&>svg]:w-sizing-comp-button-tiny-icon [&>svg]:h-sizing-comp-button-tiny-icon',
]);
